import actions from './actions'
import api from './api'
import file from './file'

export default [api, file, actions]
